"use client";

import { CarinaPartnersPill } from "@/components/partners/carina-partners-pill";
import {
  PARTNER_REVEAL_MOTION_CLASS,
  PARTNER_REVEAL_STAGGER_MS,
  partnerColumnRevealStyle,
} from "@/components/partners/partner-column-reveal";
import { PartnerSiteLink } from "@/components/partners/partner-site-link";
import { ActionButton } from "@/components/ui/action-button";
import { useScrollAnimate } from "@/hooks/use-scroll-animate";
import Image from "next/image";

export function AopsSection() {
  const textAnimate = useScrollAnimate();
  const imageAnimate = useScrollAnimate();

  return (
    <section className="bg-white py-12 md:py-16 lg:py-20">
      <div className="mx-auto px-3 sm:px-4 max-w-[1024px]">
        <div className="flex flex-col md:flex-row items-center md:items-center gap-8 md:gap-12">
          {/* Right: Logo, text, and button — slides in from right */}
          <div
            ref={textAnimate.ref}
            className={`w-full md:w-2/5 text-center md:text-left order-1 md:order-2 ${PARTNER_REVEAL_MOTION_CLASS}`}
            style={partnerColumnRevealStyle(textAnimate.isVisible, "right", {
              delayMs: PARTNER_REVEAL_STAGGER_MS,
            })}
          >
            <div className="mb-4 flex flex-col items-center md:items-start">
              <CarinaPartnersPill />
              <Image
                src="/images/marketing/partners/aops/logo.svg"
                alt="AoPS Online logo"
                width={150}
                height={50}
                className="inline-block h-12 md:h-16 w-auto"
              />
            </div>
            <p className="text-base md:text-lg text-gray-700 text-pretty mb-6">
              Art of Problem Solving (makers of Beast Academy) has a 100% free online math learning
              system called Alcumus. It uses adaptive AI to challenge high-performing 5th-12th grade
              math students with questions optimized to their abilities.
            </p>
            <ActionButton href="https://artofproblemsolving.com/alcumus">
              Check it out!
            </ActionButton>
            <PartnerSiteLink href="https://artofproblemsolving.com/alcumus" />
          </div>

          {/* Left: Hero image — slides in from left */}
          <div
            ref={imageAnimate.ref}
            className={`w-full md:w-3/5 order-2 md:order-1 ${PARTNER_REVEAL_MOTION_CLASS}`}
            style={partnerColumnRevealStyle(imageAnimate.isVisible, "left")}
          >
            <div className="relative w-full">
              <Image
                src="/images/marketing/partners/aops/hero.webp"
                alt="AoPS Online learning platform with Beast Academy books"
                width={600}
                height={400}
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
